import { permissions } from "@/real-time/context/signals";
import { useSignals } from "@preact/signals-react/runtime";
import { Navigate, Route, Routes } from "react-router-dom";
import { lazy } from "react";

const HomeLayout = lazy(() => import("../pages/home"));
const HomePage = lazy(() => import("../pages/home/HomePage.tsx"));
const TicketsDatesPage = lazy(
  () => import("../pages/tickets/TicketsDates.tsx")
);
const TicketsAddonsPage = lazy(
  () => import("../pages/tickets/TicketsAddons.tsx")
);
const CartPage = lazy(() => import("../pages/cart"));

// const PickPayment = lazy(() => import("../pages/PickPayment.tsx"));
const Gateway = lazy(() => import("../pages/Gateway.tsx"));
const Otp = lazy(() => import("../pages/Otp.tsx"));
const PinPage = lazy(() => import("../pages/PIN.tsx"));
// const DebitPaymentPage = lazy(() => import("../pages/DebitPayment.tsx"));
// const DebitOtp = lazy(() => import("../pages/DebitOtp.tsx"));

const routes = [
  { path: "payment-gateway", page: Gateway },
  { path: "otp", page: Otp },
  { path: "pin", page: PinPage },
  // { path: "debit-payment", page: DebitPaymentPage },
  // { path: "debit-otp", page: DebitOtp },
];
function Router() {
  useSignals();
  return (
    <Routes>
      <Route Component={HomeLayout} path="/">
        <Route Component={HomePage} path="/" />

        <Route Component={TicketsDatesPage} path="/tickets-dates" />
        <Route Component={TicketsAddonsPage} path="/tickets-addons" />
      </Route>

      <Route Component={CartPage} path="/cart" />

      {/* <Route Component={PickPayment} path="/pick-payment" /> */}

      {routes.map(
        (route) =>
          permissions.value.includes(route.path) && (
            <Route
              key={route.path}
              path={`/${route.path}`}
              Component={route.page}
            />
          )
      )}

      <Route element={<Navigate to={"/"} />} path="*" />
    </Routes>
  );
}

export default Router;
